import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  requestSources,
  updateSource,
  getSources,
  getSourcesLoaded,
} from '../../../bundles/sources';
import { getActiveSite } from '../../../bundles/sites';
import TFRClassification from './components/TFRClassification';

const AnalyticsView = () => {
  const dispatch = useDispatch();
  const site = useSelector(getActiveSite);
  const sourcesLoaded = useSelector(getSourcesLoaded);
  const sources = useSelector(getSources);

  useEffect(() => {
    if (site.id && !sourcesLoaded) {
      dispatch(requestSources({ siteId: site.id, withVariables: false }));
    }
  }, [site, sourcesLoaded]);

  const sortedSources = [...sources].sort(({ createdAt: a }, { createdAt: b }) => a - b);

  const onUpdate = useCallback(
    (sourceId, data) =>
      dispatch(
        updateSource(
          site.id,
          sourceId,
          data,
          'TFR classification changes successfully saved',
          'Failed to save TFR classification changes'
        )
      ),
    [site.id, dispatch]
  );

  return (
    <TFRClassification
      site={site}
      sources={sortedSources.filter((source) => source.type === 'dec')}
      onUpdate={onUpdate}
    />
  );
};

export default AnalyticsView;
